export const defaultQuery = `
query {
  me {
    name
  }
  
  # boards(ids:[13542, 68097]) {
  boards(limit:1) {
    name
    
    columns {
      title
      id
      type
    }
    
    groups {
    	title
      id
    }
    
    items {
      name
      group {
        id
      }
      
      column_values {
        id
        value
      }
    }
  }
}`;
